import { AppForm } from 'components/AppFormLayout/AppForm'
import React, { useEffect, useState } from 'react'
import { initPageId, initPageMode } from 'utils'

import { FormDemoData } from './FormDemoData'
import { AppFormActionProps } from 'components/AppFormLayout/AppFormAction'

export const FormDemo = () => {
	const [customerData, setCustomerData] = useState({ disabled: 0, organ_id: 0 })
	const [mode, setMode] = useState(initPageMode())
	const [keyValue, setKeyValue] = useState(initPageId())
	const refAppForm = React.useRef()
	// let ModuleJs = require('modules/Demo/DemoNavPageFunction').default

	const saveForm = () => {
		if (typeof refAppForm.current === 'undefined') {
			return
		}
		;(refAppForm.current as any).saveForm && (refAppForm.current as any).saveForm()
	}
	const a = 'test'
	const FormDemoActionData = [
		{
			title: '保存',
			id: 'btnSave',
			type: 'primary',
			appEventList: [{ name: 'click', type: 'action', actionType: 'customer', functionName: 'test' }],
		},
		// { title: '取消', type: 'default', action: ModuleJs[a] },
		{ title: '重置', type: 'default' },
	] as AppFormActionProps[]

	useEffect(() => {
		// DemoNavPageFunction = require('modules/Demo/DemoNavPageFunction').DemoNavPageFunction
		// console.log(DemoNavPageFunction)
		// let DemoNavPageFunction = require('modules/Demo/DemoNavPageFunction')
		// ModuleJs.init({ a: refAppForm })
	}, [])

	return (
		<AppForm
			ref={refAppForm}
			defaultTabId={0}
			mode={mode}
			customerData={customerData}
			entity="app_user"
			keyName="id"
			keyValue={keyValue}
			apiPath="/api/user/getOne"
			appFormTabList={FormDemoData}
			appFormActionList={FormDemoActionData}
		/>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/FormDemo.tsx